import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import CasinoIcon from '@mui/icons-material/Casino';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ShopIcon from '@mui/icons-material/Shop';
import { Box } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FC, useState } from 'react';

import CustomListItem from './CustomListItem';

const CollapsableMaexchenList: FC = () => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <List
      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      component="nav"
    >
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          <CasinoIcon />
        </ListItemIcon>
        <ListItemText primary="Mäxchen" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Box sx={{ pl: 1 }}>
            <CustomListItem
              to="/bonus-catalogue"
              title="Prämienkatalog"
              icon={<ProductionQuantityLimitsIcon />}
            />
          </Box>
          <Box sx={{ pl: 1 }}>
            <CustomListItem
              to="/material-list"
              title="Materialliste"
              icon={<QrCodeIcon />}
            />
          </Box>
          <Box sx={{ pl: 1 }}>
            <CustomListItem
              to="/logs"
              title="Logs"
              icon={<BubbleChartIcon />}
            />
          </Box>
          <Box sx={{ pl: 1 }}>
            <CustomListItem
              to="/orders"
              title="Bestellungen"
              icon={<ShopIcon />}
            />
          </Box>
          <Box sx={{ pl: 1 }}>
            <CustomListItem
              to="/overview"
              title="Export"
              icon={<CloudDownloadIcon />}
            />
          </Box>
        </List>
      </Collapse>
    </List>
  );
};

export default CollapsableMaexchenList;
